import React, { useState, useEffect, useContext } from 'react';


import SimpleTable from '../../components/tables/simpleTable';

import RecoverModal from '../../components/modals/recoverModal';
import VoidModal from '../../components/modals/voidModal';
import ViewModal from '../../components/modals/viewModal';
import PaymentForm from './paymentsForm';

import SearchFilter from '../../components/filters/search';
import CustomButton from '../../components/buttons/customButton';
import IsActiveFilter from '../../components/filters/isActive';
import AddButton from '../../components/buttons/addButton';
import DataFilter from '../../components/filters/dataFilter';
import DatePicker from '../../components/filters/datePicker';

import { FiRotateCcw, FiPrinter } from "react-icons/fi";

import { FcViewDetails } from "react-icons/fc";

import Loader from '../../components/loader/loader';
import { numberFormatter, totalFormatter, decimalFormatter } from '../../components/formatters/numberFormatter';
import { dateFormatter } from '../../dynamic/dateFormatter';
import { typeFormatter, paymentTypeFormatter, statusFormatter, statusTextFormatter } from '../../components/formatters/defFormatter';
import { dateTableFormatter } from '../../dynamic/dateFormatter';
import toast from 'react-hot-toast';
import { Space, Input, Tag, Button, Spin, Modal, Card } from 'antd';

import Select from 'react-select';
import AsyncSelect from 'react-select/async';

import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../init/getData';




function Payment(props) {

  let { type, isDebit } = props;

  const { api, userData, settingData, devData, yearId, companyId, mainCurrency, secondaryCurrency } = useContext(DataContext);
  const userRole = userData.role;
  const [loadingCounter, setLoadingCounter] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);
  const roundTo = settingData.roundTo;


  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);



  const table = 'journalVoucher';
  const title = type;


  const today = new Date().toISOString().split('T')[0];

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);
  const [filter, setFilter] = useState({ search: '', isActive: 'true', fromDate: today, toDate: today, type: [type], companyId, yearId });

  //change Type
  useEffect(() => {
    setFilter(prevFilter => ({ ...prevFilter, type: [type] }));
  }, [type]);

  const [showViewModal, setShowViewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showModal, setShowModal] = useState(false);


  const recoverModal = (e) => {
    if (!showRecoverModal) {
      setIdRow(e);
    }
    setShowRecoverModal(!showRecoverModal);
  }

  const deleteModal = (e) => {
    if (!showDeleteModal) {
      setIdRow(e);
    }
    setShowDeleteModal(!showDeleteModal);
  }

  const viewModal = (e) => {
    if (!showViewModal) {
      setIdRow(e);
    }
    setShowViewModal(!showViewModal);
  }

  const openModal = (e) => {
    if (!showModal && e) {
      setIdRow(e);
    }
    else {
      setIdRow(null);
    }
    setShowModal(!showModal);
  }



  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  //Excel Data
  const getExcelData = (data) => {

    const transformedData = [];
    data.forEach(item => {

      const newItem = {
        id: item.id,
        refNumber: item.refNumber,
        date: item.createdAt, 
        paymentType: item.paymentType, 
        account: item.account?.english || item.account?.name, 
        currency: item.currency?.code || 'N/A', 
        Total: item.debit, 
        [mainCurrency?.code || 'MainCurrency']: item.totalDebit, 
        [secondaryCurrency?.code || 'SecondaryCurrency']: item.secondaryTotalDebit, 
        details: item.details,
        status: statusTextFormatter(item.status),   
      };
  
      transformedData.push(newItem);
    });

    return { transformedData };  
  };

  let newColumnDefs = [
    { title: 'ID', dataIndex: 'id', width: '6%', sorter: (a, b) => a.age - b.age },
    { title: 'Ref#', dataIndex: 'refNumber', width: '6%' },
    { title: 'Date', dataIndex: 'date', width: '8%' },
    { title: 'Payment', dataIndex: 'paymentType', render: paymentTypeFormatter },
    { title: 'Account', dataIndex: 'account', render: (account) => (account?.english), width: '10%' },
    { title: 'Currency', dataIndex: 'currency', render: (currency) => (currency?.code), width: '8%' },
    { title: 'Total', dataIndex: 'debit', render: numberFormatter },
    { title: mainCurrency?.code, dataIndex: 'totalDebit', render: numberFormatter },
    { title: secondaryCurrency?.code, dataIndex: 'secondaryTotalDebit', render: numberFormatter },
    { title: 'Details', dataIndex: 'details', width: '10%' },
    { title: 'Status', dataIndex: 'status', render: statusFormatter },
  ];

  useEffect(() => {

    newColumnDefs.push(
      {
        title: 'View',
        width: '5%',
        render: (_, record) => (
          <FcViewDetails size={18} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => viewModal(record)} />
        ),
      },
      {
        title: 'Edt',
        width: '5%',
        render: (_, record) => (
          <FiEdit size={16} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => openModal(record)} />
        ),
      },
      {
        title: 'Void',
        width: '5%',
        render: (_, record) => (record.isActive ? (
          <BiSolidTrash size={18} style={{ cursor: 'pointer', color: '#e6434f' }} onClick={() => deleteModal(record)} />
        ) : <FcUndo size={18} style={{ cursor: 'pointer', color: '#e6434f' }} onClick={() => recoverModal(record)} />
        )
      }
    );

    setColumnDefs(newColumnDefs);

  }, []);


  const tableFooter = (
    <div></div>
  )

  return (
    <div>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <div>
          <Row className='g-2 mb-3'>

            <Col md={2}>
              <SearchFilter setFilter={setFilter} />
            </Col>

            <Col md={4}>
              <DatePicker setFilter={setFilter} filter={filter} />
            </Col>

            <Col md={4}>
            </Col>

            <Col md={2} className="d-flex justify-content-end">
              <Button onClick={refreshTableFunction}>
                <FiPrinter size={18} />
              </Button>
              <Button onClick={refreshTableFunction}>
                <FiRotateCcw size={18} />
              </Button>
              <Button
                style={{ backgroundColor: '#23576a', color: 'white' }}
                onClick={() => openModal()} >Add</Button>
            </Col>

          </Row>

          <SimpleTable
            filter={filter}
            showAddModal={showModal}
            table={table}
            title={title}
            columnDefs={columnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            refreshTable={refreshTable}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
            selection={true}
          />


          <ViewModal
            showModal={showViewModal}
            toggleModal={viewModal}
            journalVoucher={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
            data={{ id: idRow?.id, journalVoucher: idRow }}
          />

          <VoidModal
            showModal={showDeleteModal}
            toggleModal={deleteModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
            data={{ id: idRow?.id, journalVoucher: idRow }}
          />


          <RecoverModal
            showModal={showRecoverModal}
            toggleModal={recoverModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
            data={{ id: idRow?.id, journalVoucher: idRow }}
          />

          <PaymentForm
            showModal={showModal}
            toggleModal={openModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            type={type}
            isDebit={isDebit}
          />
        </div>
      }


    </div>
  )
}

export default Payment;
